import { useState, useRef, useEffect } from 'react';
import Modal from '../../../components/Modal';
import { useModal } from '../../../hooks/useModal';
import { formShell } from '../../../styles/formShell';

const LabelCard = ({ label, onEdit, onDelete, readOnly = false }) => {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef(null);
    const { isOpen, openModal, closeModal } = useModal();

    useEffect(() => {
        if (readOnly) return undefined;

        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [readOnly]);

    const handleDelete = () => {
        openModal();
        setShowMenu(false);
    };

    const handleConfirmDelete = () => {
        onDelete(label.id);
        closeModal();
    };

    const handleEdit = () => {
        onEdit();
        setShowMenu(false);
    };

    return (
        <div className={readOnly ? formShell.labelRowReadonly : formShell.labelRow}>
            <div className={formShell.labelRowInner}>
                <span
                    className={formShell.colorSwatch}
                    style={{ backgroundColor: label.color }}
                    aria-hidden="true"
                />
                <span className={readOnly ? formShell.labelNameReadonly : formShell.labelName}>
                    {label.name}
                </span>
            </div>

            {!readOnly && (
                <div className="relative shrink-0" ref={menuRef}>
                    <button
                        type="button"
                        className={formShell.labelMenuBtn}
                        onClick={() => setShowMenu(!showMenu)}
                        title="メニューを開く"
                        aria-expanded={showMenu}
                        aria-haspopup="true"
                    >
                        <span className="material-symbols-outlined text-icon-control">more_vert</span>
                    </button>

                    {showMenu && (
                        <div className={formShell.labelMenuDropdown} role="menu">
                            <button
                                type="button"
                                className={formShell.labelMenuItem}
                                onClick={handleEdit}
                                role="menuitem"
                            >
                                <span className="material-symbols-outlined text-icon-control">edit</span>
                                編集
                            </button>
                            <button
                                type="button"
                                className={`${formShell.labelMenuItem} ${formShell.labelMenuItemDanger}`}
                                onClick={handleDelete}
                                role="menuitem"
                            >
                                <span className="material-symbols-outlined text-icon-control">delete</span>
                                削除
                            </button>
                        </div>
                    )}

                    <Modal
                        isOpen={isOpen}
                        onClose={closeModal}
                        title={`「${label.name}」を削除しますか？`}
                        size="medium"
                        actions={[
                            { label: 'キャンセル', variant: 'secondary', onClick: closeModal },
                            { label: '削除', variant: 'danger', onClick: handleConfirmDelete },
                        ]}
                    >
                        <p>この操作は取り消せません。</p>
                    </Modal>
                </div>
            )}
        </div>
    );
};

export default LabelCard;
